import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=32d8b328&scoped=true&"
import script from "./Full.vue?vue&type=script&lang=js&"
export * from "./Full.vue?vue&type=script&lang=js&"
import style0 from "./Full.vue?vue&type=style&index=0&id=32d8b328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d8b328",
  null
  
)

component.options.__file = "Full.vue"
export default component.exports